import type { ByfunnPulseContextProviderConfig } from './types.js';

import { frontendConfig } from '../../core/system/config/frontend.server.js';

const isProduction = ['convox-production', 'convox-failover'].includes(
  frontendConfig.serverRuntime,
);

export const defaultByfunnPulseConfig: ByfunnPulseContextProviderConfig = {
  providerId: 'aftenposten',
  product: 'vink',
  productTag: 'vink',
  targetNewsroom: 'vink',
  stage: isProduction ? 'Pro' : 'Pre',
};
